import React from 'react';
import { useTranslation } from 'react-i18next';
import { VERTICAL_PRESETS, VERTICAL_KEYS } from '../../lib/data/verticalPresets';

const TIMEZONES = [
  'America/Argentina/Buenos_Aires',
  'America/Montevideo',
  'America/Santiago',
  'America/Mexico_City',
  'America/Bogota',
];

// Paso 1 — Selección de vertical (radio cards) + datos del negocio.
function StepVertical({ state, errors, onSelectVertical, onUpdateOrg }) {
  const { t } = useTranslation();
  const { vertical, org } = state;

  return (
    <div className="sw-step">
      <h2 className="sw-step-title">{t('setupWizard.step1.title', '¿Qué tipo de negocio es?')}</h2>

      <div className="sw-vertical-grid" role="radiogroup" aria-label={t('setupWizard.step1.title')}>
        {VERTICAL_KEYS.map((key) => {
          const preset = VERTICAL_PRESETS[key];
          const selected = vertical === key;
          return (
            <button
              type="button"
              key={key}
              role="radio"
              aria-checked={selected}
              className={`sw-vertical-card ${selected ? 'selected' : ''}`}
              onClick={() => onSelectVertical(key)}
            >
              <span className="sw-vertical-icon" aria-hidden="true">
                {preset.icon}
              </span>
              <span className="sw-vertical-label">
                {t(`setupWizard.vertical.${key}`, preset.label)}
              </span>
            </button>
          );
        })}
      </div>
      {errors.vertical && (
        <p className="sw-error">{t('setupWizard.errors.verticalRequired', 'Elegí un tipo de negocio')}</p>
      )}

      <div className="sw-form">
        <label className="sw-field">
          <span className="sw-label">
            {t('setupWizard.step1.name', 'Nombre del negocio')} *
          </span>
          <input
            type="text"
            className="sw-input"
            value={org.name}
            onChange={(e) => onUpdateOrg({ name: e.target.value })}
            placeholder={t('setupWizard.step1.namePlaceholder', 'NewPort Padel')}
          />
          {errors['org.name'] && (
            <span className="sw-error">{t('setupWizard.errors.required', 'Requerido')}</span>
          )}
        </label>

        <label className="sw-field">
          <span className="sw-label">
            {t('setupWizard.step1.phone', 'WhatsApp Business')} *
          </span>
          <input
            type="tel"
            className="sw-input"
            value={org.phone}
            onChange={(e) => onUpdateOrg({ phone: e.target.value })}
            placeholder="+54 9 11 3764-0000"
          />
          {errors['org.phone'] && (
            <span className="sw-error">{t('setupWizard.errors.required', 'Requerido')}</span>
          )}
        </label>

        <label className="sw-field">
          <span className="sw-label">{t('setupWizard.step1.email', 'Email del dueño')} *</span>
          <input
            type="email"
            className="sw-input"
            value={org.email}
            onChange={(e) => onUpdateOrg({ email: e.target.value })}
            placeholder="dueno@newportpadel.com"
          />
          {errors['org.email'] === 'required' && (
            <span className="sw-error">{t('setupWizard.errors.required', 'Requerido')}</span>
          )}
          {errors['org.email'] === 'invalidEmail' && (
            <span className="sw-error">
              {t('setupWizard.errors.invalidEmail', 'Email inválido')}
            </span>
          )}
        </label>

        <label className="sw-field">
          <span className="sw-label">{t('setupWizard.step1.timezone', 'Zona horaria')}</span>
          <select
            className="sw-input"
            value={org.timezone}
            onChange={(e) => onUpdateOrg({ timezone: e.target.value })}
          >
            {TIMEZONES.map((tz) => (
              <option key={tz} value={tz}>
                {tz}
              </option>
            ))}
          </select>
        </label>
      </div>
    </div>
  );
}

export default StepVertical;
